import events from '../../services/events'
import customOccasions from '../../services/custom-occasions'
import { eventFromDraft } from './draft'
import { EditorSession } from './session'

export async function saveEntry(s: EditorSession): Promise<void> {
    const d = s.draft
    if (d.kind === 'occasion') {
        const patch = { title: d.title.trim(), repeat: d.occasionRepeat, reminder: d.reminder }
        if (s.editing) customOccasions.update(s.editing, patch)
        else {
            const { jy, jm, jd, gy, gm, gd, hy, hm, hd } = s.day
            s.original = customOccasions.add({ ...patch, jy, jm, jd, gy, gm, gd, hy, hm, hd,
                source: s.adopting || undefined })
            s.editing = s.original.id
            s.pickKind = false
        }
        return
    }
    const shaped = eventFromDraft(d, s.day)
    if (s.editing) events.update(s.editing, shaped)
    else s.editing = events.add(shaped).id
    s.pickKind = false
}

export async function removeEntry(s: EditorSession): Promise<void> {
    if (s.draft.kind === 'occasion') customOccasions.remove(s.editing)
    else if (s.editing) events.remove(s.editing)
}
